import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { SelectAlpha } from '@yonderland/andes-react';
import { hasItems } from '../../../../util/ArrayUtil';
export const CountrySelector = ({ countries, selectedId, loading, lang, changeDeliveryCountry, }) => {
    const items = useMemo(() => countries.map(country => {
        var _a, _b;
        return ({
            text: (_b = (_a = country.countryTranslations[lang.toUpperCase()]) === null || _a === void 0 ? void 0 : _a.countryDescription) !== null && _b !== void 0 ? _b : '',
            id: country.countryId,
        });
    }), [countries, selectedId, lang]);
    const handleChangeCountry = (country) => {
        if (Number(country.id) !== selectedId) {
            changeDeliveryCountry(Number(country.id));
        }
    };
    if (!hasItems(items) || !selectedId)
        return null;
    return (_jsx(SelectAlpha, { name: "country-select", input: { id: 'country-select-input', disabled: loading, required: true }, items: items, value: selectedId, onSelect: handleChangeCountry }));
};
